module.exports = __webpack_public_path__ + "img/tgi.bb8431b8.png";